// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLoading-module--container--1DaBO","loading":"PageLoading-module--loading--2bg9u"};